/**
 * ClassName utility function
 *
 * A utility for conditionally joining classNames together.
 * Similar to clsx but optimized for our design system.
 */

import { type ClassValue, clsx } from 'clsx';

/**
 * Combines class names into a single string
 * @param inputs - Class values to combine
 * @returns Combined class string
 */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}
